import { API } from "@/services"

export const PROMPTS_ENDPOINTS = {
  create(data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts`,
      method: 'POST',
      data,
    })
  },
  list(params={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts`,
      method: 'GET',
      params,
    })
  },
  test(data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts/test`,
      method: 'POST',
      data,
    })
  },
  getById(id='',params={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts/${id}`,
      method: 'GET',
      params,
    })
  },
  update(id='',data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts/${id}`,
      method: 'PUT',
      data,
    })
  },
  delete(id='',data={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts/${id}`,
      method: 'DELETE',
      data,
    })
  },
  openaiPayload(id='',params={}){
    return API.Axios.humanify.v1.request({
      url: `admin/prompts/${id}/payload`,
      method: 'GET',
      params,
    })
  },
}